<template>
  <div>
    <highcharts
      :options="chartOptions"
    />
  </div>
</template>

<script>
import { Chart } from 'highcharts-vue'

// const getData = (n, num = 1) => {
//   var arr = []
//   var i
//   var x
//   var a
//   var b
//   var c
//   var spike
//   for (
//     i = 0, x = Date.UTC(new Date().getUTCFullYear(), 0, 1) - n * 36e5;
//     i < n;
//     i = i + 1, x = x + 36e5
//   ) {
//     if (i % 100 === 0) {
//       a = 2 * Math.random()
//     }
//     if (i % 1000 === 0) {
//       b = 2 * Math.random()
//     }
//     if (i % 10000 === 0) {
//       c = 2 * Math.random()
//     }
//     if (i % 50000 === 0) {
//       spike = 10
//     } else {
//       spike = 0
//     }
//     const val1 = 2 * Math.sin(i / 100) + a + b + c + spike + Math.random()
//     arr.push([
//       x,
//       num * val1
//     ])
//   }
//   return arr
// }
// var n = 500
// var data = getData(n, 3)
// console.log(data)

export default {
  name: 'Chart',
  props: {
    data: {
      type: Array,
      default: null
    }
  },
  components: {
    highcharts: Chart
  },
  data () {
    return {
      configChart: {
        colors: ['#e8e909', '#0a70e8', '#5ed441', '#de0b0b', '#aaeeee', '#ff0066', '#eeaaee',
          '#165307', '#841010', '#042b58', '#09dede'],
        title: {
          text: 'Bảng thập thần theo lưu niên',
          style: {
            color: '#000',
            textTransform: 'none'
          }
        },
        subtitle: {
          text: 'Chạm và kéo để xem chi tiết',
          style: {
            color: '#000',
            textTransform: 'none'
          }
        },
        tooltip: {
          valueDecimals: 2
        },
        chart: {
          zoomType: 'x',
          backgroundColor: {
            linearGradient: [0, 0, 500, 500],
            stops: [
              [0, 'rgba(183,184,188,0.65)'],
              [1, 'rgba(189,190,194,0.65)']
            ]
          },
          style: {
            color: '#000',
            // stroke: '#fff',
            fontFamily: 'Lucida Grande, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif'
          }
        },
        xAxis: {
          type: 'datetime',
          labels: {
            style: {
              color: '#000'
            }
          }
        },
        yAxis: {
          title: {
            text: 'Điểm',
            style: {
              color: '#666262'
            }
          },
          labels: {
            style: {
              color: '#000'
            }
          }
        },
        series: []
      }
    }
  },
  computed: {
    chartOptions () {
      return {
        ...this.configChart,
        series: this.data.map((item) => {
          return {
            ...item,
            lineWidth: 1
          }
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
